import axios from "axios";
import UrlConfigs from "../configs/UrlConfig";

export default axios.create({
  baseURL: "https://kewgreen.wegosecure.com/api/",
  headers: {
    "Content-type": "application/json",
  },
});
